import { call, put } from 'redux-saga/effects';

import api, { makeOptions } from '../../services/api';
import LdProjetoPesquisaSocioeconomicaListActions from '../ducks/ld-projeto-pesquisa-socioeconomica';

const dataLocal = JSON.parse(localStorage.getItem('persist:Spcine'));
// const getAuthData = (state) => state.auth.data;

export function* fetchSelect(action) {
  try {
    // const authData = yield select(getAuthData);
    const url = `ld-projeto?paginate=false`;
    const { data: responseData } = yield call(
      api.get,
      url,
      makeOptions(dataLocal.auth.data),
    );
    const { data } = responseData;
    const list = data.map(({ uuid, name }) => ({
      value: uuid,
      label: name,
    }));
    yield put(LdProjetoPesquisaSocioeconomicaListActions.showSuccess(list));
  } catch (err) {
    yield put(
      LdProjetoPesquisaSocioeconomicaListActions.showFailure(
        err.response.data.error.message,
      ),
    );
  }
}
